import { useEffect, useState } from "react";
import ReactJson from "react-json-view";
import { conversionUtils } from "@centivo-business/utils";
import ReactDiffViewer from "react-diff-viewer";
import XMLViewer from "react-xml-viewer";
import Modal from "../modal/Modal";
import HrpDate from "../shared/HrpDate";
import { fetchBnftPlanComp, fetchValueFromValueList } from "../../utils/apiUtils";
import ValueListTable from "./ValueListTable";
import { convertDate, convertJsonToXml, downloadTxtFile, findQuotedWordsAndPrecedingCode, getHighlightedText, sortByKeys, toWords } from "../../utils/commonUtils";
import { useQuery } from "@tanstack/react-query";
import IngestionFileLogs from "../edi/IngestionFileLogs";
import _ from "lodash";
import BenefitPlanProvision from "./BenefitPlanProvision";
import TicketDetails from "../support/TicketDetails";
import QInContentDetails from "../connect/QInContentDetails";
import MemberDetails from "../member/MemberDetails";
import SimpleTable from "../shared/SimpleTable";
import HrpAddress from "../shared/HrpAddress";
import HrpPaymentTypeCode from "../shared/HrpPaymentTypeCode";
import { downloadFile } from "../../utils/downloadUtils";
import JobDetails from "../jobRegistry/JobDetails";
import GroupDetails from "../jobRegistry/GroupDetails";
import { queryClient } from "../../App";
import Client from "./SharedTable/detailViews/Client";
import Employee from "./SharedTable/detailViews/Employee";
import ReinsuranceTrackerDetail from "../javelina/ReinsuranceTrackerDetail";
import SupplierContract from "./SharedTable/detailViews/SupplierContract";
import FeeComponent from "./SharedTable/detailViews/FeeComponent";
import ProviderNetwork from "./SharedTable/detailViews/ProviderNetwork";
import NetworkDefinition from "./SharedTable/detailViews/NetworkDefinition";
import PlanNetworksSection from "./SharedTable/detailViews/PlanNetworksSection";
import PractitionerRole from "./SharedTable/detailViews/PractitionerRole";
import ClaimDetails from "./SharedTable/detailViews/ClaimDetails";

//TODO extract model to its own file
const SharedTable = ({
    type,
    className,
    disableHeaderFormatting,
    columns,
    items,
    activeDraftId,
    hasNextPage,
    isFetching,
    isLoading,
    isDetailLoading,
    isFetchingNextPage,
    fetchNextPage,
    ref,
    onDetailHandler,
    onEditHandler,
    onDeleteHandler,
    onHistoryHandler,
    columnLinks,
    queryKey,
    updateAssigToMutation,
    tagResourceoMutation,
    searchText,
    disableModel,
    autoRefreshEnabled,
    sortModalJsonKeys = true,
    noResultsMessage
}) => {
    const [loading, setLoading] = useState(false);
    const [isLoadingComponent, setIsLoadingComponent] = useState(false);
    const [loadingComponentError, setLoadingComponentError] = useState(false);
    const [editError, setEditError] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showValueList, setShowValueList] = useState(false);
    const [showProvision, setShowProvision] = useState(false);
    const [showTemplateRiderDetails, setShowTemplateRiderDetails] = useState(null);

    if (!items?.length && !isFetching && !isLoading) {
        return (
            <div style={{ padding: "1rem 0rem" }}>
                {noResultsMessage ? noResultsMessage : "No results. Try changing the filter."}
            </div>
        );
    }

    const showCompnentDetails = async ({ details }) => {
        if (details?.benefitPlanCompKey) {
            try {
                setLoadingComponentError(false);
                setIsLoadingComponent(details?.benefitPlanCompKey);
                const benefitPlanComp = await fetchBnftPlanComp({ benefitPlanCompKey: details?.benefitPlanCompKey });
                //   console.log(benefitPlanComp)

                setShowTemplateRiderDetails({
                    ...details,
                    details: benefitPlanComp.rows[0],
                    valueListRider: isModalOpen?.details?.benefitPlanRidersWithDetails.find((r) => r?.detail?.category === "Value List"),
                });
            } catch (error) {
                console.log(error);
                setLoadingComponentError(error.message);
            } finally {
                setIsLoadingComponent(false);
            }
        }
    };

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                className={type === "jv-reinsurance" ? "reinsurance-tracker-modal" : ""}
                onClose={() => {
                    setShowValueList(false);
                    setIsModalOpen(false);
                    setShowTemplateRiderDetails(false);
                    if (queryKey) {
                        queryClient.invalidateQueries([queryKey])
                    }
                }}
            >
                <div style={{ padding: "1rem 1rem", width: "100%", height: "100%", overflowY: "scroll" }}>
                    {type === "practitioners" ? <Practitioner data={isModalOpen} /> : type === "templates" ? (
                        <TemplateRiderDetails data={isModalOpen} />
                    ) : type === "components" ? (
                        <Components data={isModalOpen} />
                    ) : type === 'account' ? (
                        <Account onEditHandler={onEditHandler} onDeleteHandler={onDeleteHandler} setIsModalOpen={setIsModalOpen} data={isModalOpen} />
                    ) : ["benefitplan", "valuelist", "provision"].includes(type) ? (
                        <>
                            {isModalOpen?.benefitPlanHccId && (
                                <>
                                    <div style={{ display: "flex", alignItems: "start", justifyContent: "space-between" }}>
                                        <div>
                                            <p>Account</p>
                                            <p style={{ fontWeight: 600, fontSize: "1rem" }}>{isModalOpen?.details?.accountHccId}</p>
                                            <p className="sub-title">{`${isModalOpen?.details?.accountName} ( Account Identifier|Key: ${isModalOpen?.details.accountIdentifier} )`}</p>

                                            <br />
                                            <p>Plan</p>
                                            <p className="title">{isModalOpen?.benefitPlanName}</p>
                                            <p className="sub-title">{isModalOpen?.benefitPlanHccId}</p>
                                            <p className="sub-title" style={{ paddingTop: ".4rem" }}>
                                                {isModalOpen?.benefitPlanDesc}
                                            </p>

                                            <br />
                                            <p className="sub-title">effectiveStartDate: {isModalOpen?.details?.effectiveStartDate}</p>
                                            <p className="sub-title">benefitPlanYear: {isModalOpen?.benefitPlanYear}</p>

                                            <p className="sub-title">Default value list: {isModalOpen?.defaultValueListByTemplate?.label}</p>

                                            {!showProvision && (
                                                <p className="clickable-link" style={{ paddingTop: "1rem" }} onClick={() => setShowProvision(true)}>
                                                    Provision
                                                </p>
                                            )}
                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column", gap: "1rem", justifyContent: "end", alignItems: "end" }}>
                                            {loading ? (
                                                <RowLoader />
                                            ) : (
                                                onEditHandler && ( // && !isModalOpen.hasVersionExpired
                                                    <div style={{ display: "flex", gap: "1rem" }}>
                                                        <button
                                                            className="edit-btn"
                                                            onClick={async () => {
                                                                try {
                                                                    setEditError("");
                                                                    setLoading(true);
                                                                    await onEditHandler?.({ data: isModalOpen });
                                                                } catch (err) {
                                                                    console.log(err);
                                                                    setEditError(err.message);
                                                                } finally {
                                                                    setLoading(false);
                                                                }
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                    </div>
                                                )
                                            )}

                                            {editError && <p className="danger">{editError}</p>}
                                        </div>
                                    </div>
                                </>
                            )}

                            {showProvision ? (
                                <>
                                    <p
                                        onClick={() => {
                                            setShowProvision(false);
                                            // setShowTemplateRiderDetails(null)
                                        }}
                                        className="clickable-link"
                                        style={{ padding: "1rem 0rem 0rem 0rem" }}
                                    >
                                        Back
                                    </p>
                                    <BenefitPlanProvision
                                        benefitPlanHccId={isModalOpen?.benefitPlanHccId}
                                        benefitPlanName={isModalOpen?.benefitPlanName}
                                        benefitPlanKey={isModalOpen.benefitPlanKey}
                                        benefitPlanHistoryFactKey={isModalOpen.benefitPlanHistoryFactKey}
                                    />
                                </>
                            ) : showValueList ? (
                                <>
                                    <p
                                        onClick={() => {
                                            setShowValueList(false);

                                            // setShowTemplateRiderDetails(null)
                                        }}
                                        className="clickable-link"
                                        style={{ padding: "1rem 0rem 0rem 0rem" }}
                                    >
                                        Back
                                    </p>
                                    <ValueListTable
                                        benefitPlanHccId={isModalOpen?.benefitPlanHccId}
                                        benefitPlanName={isModalOpen?.benefitPlanName}
                                        benefitPlanKey={isModalOpen.benefitPlanKey}
                                        benefitPlanHistoryFactKey={isModalOpen.benefitPlanHistoryFactKey}
                                    />
                                </>
                            ) : showTemplateRiderDetails ? (
                                <>
                                    <p
                                        onClick={() => {
                                            //setShowValueList(false)
                                            setShowTemplateRiderDetails(null);
                                        }}
                                        className="clickable-link"
                                        style={{ padding: "1rem 0rem 0rem 0rem" }}
                                    >
                                        Back
                                    </p>
                                    <br />
                                    <TemplateRiderDetails data={showTemplateRiderDetails} planInfo={isModalOpen} />

                                    {/* {getTemplateRiderDetails(showTemplateRiderDetails)} */}
                                </>
                            ) : isModalOpen?.benefitPlanHccId ? (
                                <>
                                    <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>Components</p>
                                    <div className="table-wrapper" style={{ height: "auto", maxHeight: "unset" }}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    {/* {Object.keys(isModalOpen?.details?.benefitPlanRiders?.benefitPlanRider?.[0]).map(k => <th key={k}>{k}</th>)} */}
                                                    <th>slotName</th>
                                                    <th>benefitPlanCompName</th>
                                                    <th>benefitPlanCompDesc</th>
                                                    {/* <th>latestVersionOfTemplate</th> */}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {isModalOpen?.details?.defaultComponentsByTemplate
                                                    //  ?.filter((a) => a.benefitPlanCompName)
                                                    ?.sort((a, b) => a.slotName?.localeCompare(b.slotName))
                                                    ?.map((r, i) => (
                                                        <tr key={'bp' + r.benefitPlanCompSlotKey + i}>
                                                            <td>{r.slotName}</td>
                                                            <td className={r.benefitPlanCompKey ? "clickable-link" : ""} onClick={() => showCompnentDetails({ details: r })}>
                                                                {r.benefitPlanCompName}
                                                            </td>
                                                            <td>{r.benefitPlanCompDesc}</td>
                                                            {/* <td>{r.latestVersionOfTemplate}</td> */}
                                                            {/* <td
                                                className={r.detail?.category === 'Value List' ? 'clickable-link' : ''}
                                                onClick={async () => {

                                                    // const result = await fetchValueFromValueList({ benefitPlanKey: isModalOpen.benefitPlanKey, benefitPlanHistoryFactKey: isModalOpen.benefitPlanHistoryFactKey })
                                                    // console.log(result)
                                                    setShowValueList(true)
                                                    //TODO show an hide value list
                                                }}

                                            >
                                                {r.detail?.category}
                                            </td> */}
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>Riders</p>
                                    <div className="table-wrapper" style={{ height: "auto", maxHeight: "unset" }}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    {/* {Object.keys(isModalOpen?.details?.benefitPlanRiders?.benefitPlanRider?.[0]).map(k => <th key={k}>{k}</th>)} */}
                                                    <th>riderIdentifier</th>
                                                    <th>riderHccId</th>

                                                    <th>riderName</th>
                                                    {/* <th>benefitPlanCompKey</th> */}

                                                    <th>category</th>
                                                    <th>slotName</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {isModalOpen?.details?.benefitPlanRidersWithDetails
                                                    ?.sort((a, b) => a.detail?.category?.localeCompare(b.detail?.category))
                                                    ?.map((r) => (
                                                        <tr key={r.riderHccId + Math.round()} style={{ backgroundColor: r.isDeprecated ? "var(--rose)" : "" }}>
                                                            <td>{r.riderIdentifier}</td>
                                                            {isLoadingComponent === r.detail?.benefitPlanCompKey ? (
                                                                <RowLoader />
                                                            ) : (
                                                                <td className={r.detail?.benefitPlanCompKey ? "clickable-link" : ""} onClick={() => showCompnentDetails({ details: r.detail })}>
                                                                    {r.riderHccId}
                                                                </td>
                                                            )}

                                                            <td>{r.riderName}</td>
                                                            {/* <td
                                                                className="clickable-link"
                                                                onClick={async () => {
                                                                    if (r.detail?.benefitPlanCompKey) {
                                                                        const benefitPlanComp = await fetchBnftPlanComp({ benefitPlanCompKey: r.detail?.benefitPlanCompKey })
                                                                        console.log(benefitPlanComp)

                                                                        setShowTemplateRiderDetails({ ...r.detail, details: benefitPlanComp.rows[0] })
                                                                    }

                                                                }}>{r.detail?.benefitPlanCompKey}</td> */}
                                                            <td
                                                                className={r.detail?.category === "Value List" ? "clickable-link" : ""}
                                                                onClick={async () => {
                                                                    // const result = await fetchValueFromValueList({ benefitPlanKey: isModalOpen.benefitPlanKey, benefitPlanHistoryFactKey: isModalOpen.benefitPlanHistoryFactKey })
                                                                    // console.log(result)
                                                                    if (r.detail?.category === "Value List") {
                                                                        setShowValueList(true);
                                                                    }

                                                                    //TODO show an hide value list
                                                                }}
                                                            >
                                                                {r.detail?.category}
                                                            </td>
                                                            <td>{r.detail?.slotName}</td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <PlanNetworksSection
                                        networkDefinitions={isModalOpen?.details?.networkDefinitions}
                                        asOf={isModalOpen?.details?.asOfDate}
                                    />
                                </>
                            ) : (
                                <></>
                            )}
                        </>
                    ) : type === "supplier-contracts" ? (
                        <SupplierContract data={isModalOpen} />
                    ) : type === "fee-components" ? (
                        <FeeComponent data={isModalOpen} />
                    ) : type === "provider-networks" ? (
                        <ProviderNetwork data={isModalOpen} />
                    ) : type === "network-definitions" ? (
                        <NetworkDefinition data={isModalOpen} />
                    ) : type === "practitioner-roles" ? (
                        <PractitionerRole data={isModalOpen} />
                    ) : type === "service-categories" ? (
                        <>
                            <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>{isModalOpen?.serviceCategoryName}</p>
                            <p className="sub-title">{isModalOpen?.definition}</p>

                            <ServiceCodes data={isModalOpen?.details?.serviceCodes} />
                            {/* {isModalOpen?.details?.serviceCodes?.map(c => <ServiceCodes key={c.serviceCategoryHistFactKey} data={c} />)} */}
                        </>
                    ) : type === "ticket" ? (
                        <TicketDetails
                            data={items?.find((item) => item.pk === isModalOpen.pk && item.sk === isModalOpen.sk)}
                            queryKey={queryKey}
                            updateAssigToMutation={updateAssigToMutation}
                        />
                    ) : type === "q-connect" ? (
                        <QInContentDetails data={items?.find((item) => item.contentArn === isModalOpen.contentArn)} queryKey={queryKey} tagResourceoMutation={tagResourceoMutation} />
                    ) : type === "claims" ? (
                        <ClaimDetails data={isModalOpen} />
                    ) : type === "edi-ingestion" ? (
                        <IngestionFileLogs fileName={isModalOpen?.pk} objectKey={isModalOpen?.formatedKey} responseKey={isModalOpen?.responseKey} bucketName={isModalOpen?.bucket} />
                    ) : type === "job-registry" ? (
                        <JobDetails job={isModalOpen} autoRefreshEnabled={autoRefreshEnabled} />
                    ) : type === "job-registry-groups" ? (
                        <GroupDetails
                            queryKey={queryKey}
                            group={items?.find((item) => item.pk === isModalOpen.pk && item.sk === isModalOpen.sk)}
                            autoRefreshEnabled={autoRefreshEnabled} />
                    ) : type === "members" ? (
                        <MemberDetails data={isModalOpen} />
                    ) : type === "employes" ?
                        <Employee data={isModalOpen} />
                        : type === "clients" ? (
                            <Client data={isModalOpen} />
                        ) : type === "jv-reinsurance" ? (
                            <ReinsuranceTrackerDetail data={isModalOpen} />
                        ) : type === "transactions" ? (
                            <TransactionDIff data={isModalOpen} />
                        ) : type === 'jv-check-payments' ? <JVCheckPayment data={isModalOpen} /> :
                            type === 'jv-payments' ? <JVPayment data={isModalOpen} /> :
                            type === 'account-audit' ? (
                                <>
                                    <p className="title">Audit Record</p>
                                    <div style={{ padding: '1rem 0' }}>
                                        <p><strong>Action:</strong> {isModalOpen.action}</p>
                                        <p><strong>Entity Type:</strong> {isModalOpen.entityType}</p>
                                        <p><strong>Entity ID:</strong> {isModalOpen.entityId}</p>
                                        <p><strong>Email:</strong> {isModalOpen.email}</p>
                                        <p><strong>Timestamp:</strong> {isModalOpen.sk}</p>
                                    </div>
                                    {(isModalOpen.requestBodyParsed || isModalOpen.requestBody) && (
                                        <>
                                            <p className="title" style={{ paddingTop: '1rem' }}>Request</p>
                                            <ReactJson
                                                style={{ padding: "1rem" }}
                                                src={isModalOpen.requestBodyParsed || (typeof isModalOpen.requestBody === 'string' ? JSON.parse(isModalOpen.requestBody) : isModalOpen.requestBody)}
                                                name={false}
                                                collapsed={1}
                                                collapseStringsAfterLength={150}
                                                displayDataTypes={false}
                                                displayObjectSize={false}
                                                sortKeys={true}
                                            />
                                        </>
                                    )}
                                    {isModalOpen.responseBody && (
                                        <>
                                            <p className="title" style={{ paddingTop: '1rem' }}>Response</p>
                                            <ReactJson
                                                style={{ padding: "1rem" }}
                                                src={typeof isModalOpen.responseBody === 'string' ? JSON.parse(isModalOpen.responseBody) : isModalOpen.responseBody}
                                                name={false}
                                                collapsed={1}
                                                collapseStringsAfterLength={150}
                                                displayDataTypes={false}
                                                displayObjectSize={false}
                                                sortKeys={true}
                                            />
                                        </>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}

                    {!showValueList && type !== 'clients' && type !== 'practitioner-roles' && type !== 'jv-reinsurance' && type !== 'claims' && (
                        <>
                            <p className="title" style={{ paddingTop: '1rem' }}>{`${type || 'JSON'}`}</p>
                            <ReactJson
                                style={{ padding: "1rem" }}
                                src={{ isModalOpen } || ""}
                                name={false}
                                collapsed={1}
                                collapseStringsAfterLength={150}
                                displayDataTypes={false}
                                displayObjectSize={false}
                                sortKeys={sortModalJsonKeys}
                            />
                        </>
                    )}
                </div>
            </Modal>

            {
                //isLoading
                isLoading ? (
                    <div style={{ padding: "0rem 0rem" }}>
                        <div style={{ width: "100%", padding: "1rem 1rem", borderRadius: ".4rem" }} className="loading"></div>
                    </div>
                ) : (
                    <div className={`table-wrapper ${className}`}>
                        <table>
                            <thead>
                                <tr>
                                    {activeDraftId && <th></th>}
                                    <th></th>
                                    {columns?.map((key) => (
                                        <th key={key + Math.random()}>{disableHeaderFormatting ? key : conversionUtils.camelToSnakeCase(key)}</th>
                                    ))}
                                    <th></th>
                                    {onHistoryHandler && <th></th>}
                                    {onDeleteHandler && <th> </th>}
                                </tr>
                            </thead>
                            <tbody>
                                {items?.map((row, i) => {
                                    return (
                                        <Row
                                            key={i + Math.random()}
                                            index={i + 1}
                                            columns={columns}
                                            row={row}
                                            disableModel={disableModel}
                                            setIsModalOpen={setIsModalOpen}
                                            onDetailHandler={onDetailHandler}
                                            onDeleteHandler={onDeleteHandler}
                                            onHistoryHandler={onHistoryHandler}
                                            columnLinks={columnLinks}
                                            searchText={searchText}
                                            isLoading={isLoading}
                                            isFetching={isFetching}
                                            isDetailLoading={isDetailLoading}
                                        />
                                    );
                                })}
                            </tbody>
                        </table>

                        <div style={{ width: "100%", padding: "1rem 0rem", display: isFetchingNextPage || hasNextPage ? "block" : "none" }} ref={ref}>
                            <button
                                onClick={() => fetchNextPage()}
                                disabled={!hasNextPage || isFetchingNextPage}
                                className="clickable-link"
                                style={{ padding: ".4rem 1rem", backgroundColor: "var(--white)", border: "none" }}
                            >
                                {isFetchingNextPage ? "Loading more..." : hasNextPage ? "Load more" : "Done"}
                            </button>
                        </div>
                        <div>
                            {isFetching && !isFetchingNextPage ? (
                                // true
                                <div style={{ padding: ".4rem" }}>
                                    {/* <div style={{ width: "100%", padding: "1rem 1rem", borderRadius: ".4rem" }} className="loading"></div> */}
                                    IsFetching...
                                </div>
                            ) : null}
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default SharedTable;

const Row = ({ index, row, columns, disableModel, setIsModalOpen, onDetailHandler, onDeleteHandler, onHistoryHandler, columnLinks, searchText, isLoading, isFetching, isDetailLoading }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteError, setDeleteError] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [historyError, setHistoryError] = useState(false);

    const hasVersionExpired = row?.["versionExpDateKey"] < new Date().getTime();
    const hasRowError = row?.["__rowHasError"];
    const hasRowWarning = row?.["__rowHasWarning"];
    const rowBackgroundColor = hasVersionExpired || hasRowError
        ? "var(--lightRed)"
        : hasRowWarning
            ? "var(--lightOragne)"
            : "";

    return (
        <tr className="tr" key={'row' + index} style={{ backgroundColor: rowBackgroundColor }}>
            <td style={{ minWidth: "40px", maxWidth: "60px" }}>{index}</td>

            {columns.map((header, i) => {
                if (header.includes("DateKey") || header.includes("StartDate")) {
                    return <td key={i + Math.random()}>{row?.[header] && <HrpDate dateKey={row?.[header]} />}</td>;
                }
                else if (header?.toLowerCase().includes("addresskey")) {
                    return <td key={i + Math.random()}>{row?.[header] && <HrpAddress addressKey={row?.[header]} />}</td>;
                }
                else if (header?.includes("paymentTypeKey")) {
                    return <td key={i + Math.random()}>{row?.[header] && <HrpPaymentTypeCode paymentTypeKey={row?.[header]} />}</td>;
                }

                else if (["startedAt", "completedAt", "createAt", "createdAt", "updatedAt", "creationTime", 'transationDate', 'readTimestamp', 'jobScheduleStartTime', 'transactionDate'].includes(header)) {
                    return <DateRow data={row?.[header]} header={header} />;
                } else if (typeof _.get(row, header) === "boolean") {
                    return <td key={i + Math.random()} style={{
                        color: _.get(row, header) ? "var(--green)" : ""
                    }}>{_.get(row, header) ? "true" : "false"}</td>;
                } else if (header === 'ttl') {
                    return <td key={i + Math.random()}>{_.get(row, header) ? `${new Date(_.get(row, header) * 1000).toLocaleString()}` : ''}</td>;
                }

                else if (["string", "number"].includes(typeof _.get(row, header))) {
                    const value = _.get(row, header)
                    const href = columnLinks?.[header]?.(row);
                    const text = getHighlightedText(value, searchText);
                    return (
                        <td key={i + Math.random()} className={['status', 'sparse'].includes(header?.toLowerCase?.()) ? 'status-td' : ''}>
                            {href ? (
                                <a className="clickable-link" href={href} target="_blank" rel="noreferrer">{text}</a>
                            ) : (
                                <span className={['status', 'sparse'].includes(header?.toLowerCase?.()) ? value : ''}>{text}</span>
                            )}
                        </td>
                    );
                }

                else if (header === 'tags') {
                    return <td className="tags" key={i + Math.random()}>{_.get(row, header)?.map?.(tag => <span key={tag} className="tag">{tag}</span>)}</td>;
                }

                else if (!_.get(row, header)) {
                    return <td key={i + Math.random()}>-</td>;
                }
                return (
                    <td key={i + Math.random()}>
                        <ReactJson
                            style={{}}
                            src={_.get(row, header) || ""}
                            name={false}
                            collapsed={1}
                            collapseStringsAfterLength={150}
                            displayDataTypes={false}
                            displayObjectSize={false}
                            sortKeys={true}
                        />
                    </td>
                );
            })}

            {
                // loading

                loading ? (
                    <RowLoader />
                ) : (
                    <>
                        <td
                            className="clickable-link more"
                            style={{ width: "80px", textAlign: "center" }}
                            onClick={async () => {
                                try {
                                    setLoading(true);
                                    setError(null);
                                    let details = {};

                                    if (onDetailHandler) {
                                        details = await onDetailHandler(row);
                                    }
                                    row.details = details;
                                    row.hasVersionExpired = hasVersionExpired;
                                    !disableModel && setIsModalOpen({ ...row, details, hasVersionExpired });
                                } catch (err) {
                                    console.log(err);
                                    setError(err.message);
                                } finally {
                                    setLoading(false);
                                }
                            }}
                        >
                            Detail
                            <p className="danger">{error}</p>
                        </td>


                    </>
                )
            }

            {onHistoryHandler && (
                historyLoading ? <RowLoader /> : (
                    <td
                        className="clickable-link more"
                        style={{ width: "80px", textAlign: "center" }}
                        onClick={async () => {
                            try {
                                setHistoryLoading(true);
                                setHistoryError(null);
                                await onHistoryHandler(row);
                            } catch (err) {
                                console.log(err);
                                setHistoryError(err.message);
                            } finally {
                                setHistoryLoading(false);
                            }
                        }}
                    >
                        History
                        <p className="danger">{historyError}</p>
                    </td>
                )
            )}

            {deleteLoading ? <RowLoader /> : <>
                {onDeleteHandler && <td
                    className="clickable-link danger"
                    style={{ width: '80px', textAlign: 'center', verticalAlign: 'middle', cursor: 'pointer' }}
                    onClick={async () => {
                        try {
                            setDeleteLoading(true)
                            setDeleteError(null)
                            await onDeleteHandler(row)
                        } catch (error) {
                            setDeleteError(error.message)
                        } finally {
                            setDeleteLoading(false)
                        }
                    }}
                >
                    {deleteLoading ? <RowLoader /> : 'Delete'}
                    <p className="danger">{deleteError}</p>
                </td>}
            </>}
        </tr>
    );
};
const daysOfWeek = ['Sun', 'Mon', 'Tues', 'Wednes', 'Thurs', 'Fri', 'Satur'];

const DateRow = ({ data, header }) => {
    const [showLocalDate, setShowLocalDate] = useState(false);

    return (
        <td
            key={Math.random()}
            className="td"
            style={{ cursor: "pointer" }}
            onMouseEnter={() => {
                const date = new Date(data)
                if (date instanceof Date && !isNaN(date.getTime())) {
                    setShowLocalDate(`${date.toLocaleString()} (${daysOfWeek[date.getDay()]})`)
                }

            }}
            onMouseLeave={() => setShowLocalDate(false)}
        >
            {showLocalDate || data || '-'}
        </td>
    );
};

const RowLoader = () => (
    <td className="td-loader">
        {/* <div>Loading...</div> */}
        {/* Loading... */}
        {/* <p className="loader" style={{ width: "40px" }} /> */}
    </td>
);

const TemplateRiderDetails = ({ data, planInfo }) => {
    if (data.valueListRider) {
        // await fetchValueFromValueList({ benefitPlanKey: data.benefitPlanKey, benefitPlanHistoryFactKey: data.benefitPlanHistoryFactKey })
        //TODO fetch the valuelist for all the variables in benefitPlanCompProvFact and display them
    }

    return (
        <>
            <p>{data?.benefitPlanRiderName ? "Rider" : "Component"}</p>
            <p className="title">{data?.benefitPlanRiderName || data?.benefitPlanCompName}</p>
            <p className="sub-title">{data?.benefitPlanRiderDesc || data?.benefitPlanCompDesc}</p>

            <br />
            <br />

            <p>Template: {data?.details?.benefitTemplateName}</p>
            {data?.details?.benefitPlanCompProvFact?.length ? (
                <>
                    <p style={{ fontSize: "1.2rem", fontWeight: "600" }}>Provisions</p>

                    {data?.details?.benefitPlanCompProvFact?.map((comp, i) => {
                        return <Provision comp={comp} key={comp.bnftPlanCompProvFactKey} planInfo={planInfo} />;
                    })}
                </>
            ) : (
                <></>
            )}

            {/* <ReactJson
            style={{ padding: "1rem" }}
            src={data || ""}
            name={false}
            collapsed={true}
            collapseStringsAfterLength={150}
            displayDataTypes={false}
            displayObjectSize={false}
            sortKeys={true}
        /> */}
        </>
    );
};

function replaceMultiple(text, replacements) {
    let updatedText = text;
    // Iterate through the array of replacements
    for (const replacement of replacements) {
        // Ensure each replacement object has 'search' and 'replace' properties
        if (replacement.search && replacement.replace !== undefined) {
            // Use replaceAll for global replacement of the 'search' string with 'replace' string
            updatedText = updatedText.replaceAll(replacement.search, replacement.replace);
        } else {
            console.warn("Invalid replacement object in array:", replacement);
        }
    }
    return updatedText;
}

const Components = ({ data }) => {
    const [searchText, setSearchText] = useState("");
    const provisionsGroupByTier = { ...Object.groupBy(data?.details?.provisions, ({ benefitTier }) => [benefitTier]) };

    const searchOptimizedProvisions = Object.keys(provisionsGroupByTier).reduce((accum, curr) => {
        const currentKey = curr; //.toLowerCase().replace(/ /g, '')
        if (accum[currentKey]) {
            accum[currentKey] += provisionsGroupByTier[curr].map((p) => p.benefitProvisionText).join(" | ");
        } else {
            accum[currentKey] = provisionsGroupByTier[curr].map((p) => p.benefitProvisionText).join(" | ");
        }

        return accum;
    }, {});

    return (
        <div>
            <p style={{ fontSize: "1.2rem", fontWeight: 600 }}>{data.benefitPlanCompName}</p>
            <div style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "start", width: "100%", padding: "1rem 0rem" }}>
                <input
                    style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search text..."
                />
            </div>
            {Object.keys(searchOptimizedProvisions)?.map((tier) => {
                return (
                    <div key={tier} style={{ paddingBottom: "1rem" }}>
                        <p style={{ padding: "1rem 1rem 0rem 1rem", fontSize: "1rem", fontWeight: 600 }}>{tier}</p>

                        {searchOptimizedProvisions[tier]?.split("|")?.map((benefitProvisionText, i) => (
                            <div key={i} style={{ padding: ".4rem 1rem" }}>
                                <p style={{ color: "var(--darkerGrey)", padding: ".4rem .8rem", borderRadius: ".4rem", fontSize: "1rem" }}>
                                    {getHighlightedText(benefitProvisionText, searchText)}
                                </p>
                            </div>
                        ))}
                    </div>
                );
            })}
        </div>
    );
};

const Account = ({ onEditHandler, onDeleteHandler, setIsModalOpen, data }) => {
    return (
        <>
            <div style={{ display: "flex", alignItems: "start", justifyContent: "space-between" }}>
                <p style={{ fontSize: "1.2rem", fontWeight: 600 }}>{data.accountName ? `${data.accountName} (${data.accountHccId})` : `${data.accountHccId}`}</p>
                <div style={{ display: "flex", gap: "1rem", justifyContent: "end", alignItems: "end" }}>
                    {onEditHandler && (
                        <button
                            className="edit-btn"
                            onClick={() => {
                                onEditHandler(data);
                                setIsModalOpen(false);
                            }}
                        >
                            Edit
                        </button>
                    )}
                    {onDeleteHandler && (
                        <button
                            className="delete-btn"
                            onClick={() => {
                                onDeleteHandler(data);
                                setIsModalOpen(false);
                            }}
                        >
                            Delete
                        </button>
                    )}
                </div>
            </div>
            <div style={{ paddingBottom: '2rem', paddingTop: '1rem' }}>
                {Object.entries(data?.details).map(([key, value]) => {
                    if (key.includes("DateKey")) {
                        return <p key={key} className="sub-title">{key}: <HrpDate dateKey={value} /></p>;
                    } else {
                        return <p key={key} className="sub-title">{key}: {value}</p>;
                    }
                })}
            </div>
        </>
    );
};

const Provision = ({ comp, planInfo = {} }) => {
    const { benefitPlanKey, benefitPlanHistoryFactKey } = planInfo || {};
    const variables = findQuotedWordsAndPrecedingCode(comp.benefitProvisionText);
    const uniqueVariablesForCategories = [...new Set(variables.filter((vObj) => vObj.precedingCode === "category").map((v) => v.quotedWord))];
    const uniqueVariablesAfterIs = [...new Set(variables.filter((vObj) => vObj.precedingCode === "is").map((v) => v.quotedWord))];

    const { data: updatedBenefitProvisionText } = useQuery({
        queryKey: ["variables", benefitPlanKey, benefitPlanHistoryFactKey, ...uniqueVariablesAfterIs],
        queryFn: async () => {
            const variableTasks = uniqueVariablesAfterIs.map((quotedWord) => fetchValueFromValueList({ valueNamePrefix: quotedWord, benefitPlanKey, benefitPlanHistoryFactKey }));
            return await Promise.all(variableTasks);
        },
        select: (data) => {
            const variablesDetails = data.map((d) => d.rows).flat();
            const benefitProvisionText = comp.benefitProvisionText.split(" ");

            const indexOfIs = benefitProvisionText.indexOf("is");
            const indexOfLabel = benefitProvisionText.indexOf("label");

            const serviceCategoy = indexOfIs ? benefitProvisionText.slice(0, indexOfIs) : benefitProvisionText;
            const valueAmtPercent = benefitProvisionText.slice(indexOfIs, indexOfLabel);
            const labels = benefitProvisionText.slice(indexOfLabel);

            // is value
            //  console.log({ benefitProvisionText, indexOfIs, indexOfLabel, serviceCategoy, valueAmtPercent, labels })
            const valueAmtPercentUpdated = replaceMultiple(
                valueAmtPercent.join(" "),
                variablesDetails.map((d) => ({
                    search: d.valueName,
                    replace: d.percentValue || d.value,
                }))
            );
            return [...serviceCategoy, valueAmtPercentUpdated, ...labels].join(" ");
        },
        enabled: !!(Object.keys(planInfo).length && variables.length),
    });

    return (
        <div style={{ padding: "1rem 0rem" }}>
            {/* <p style={{ fontWeight: "600" }}>
                {comp.benefitTier?.[0]?.tierName} {comp.provisionTypeName}
            </p> */}
            {/* <p className="sub-title">{uniqueVariablesForCategories?.join(", ")}</p> */}

            {/*         <p style={{ padding: "1rem 0rem .4rem 0rem", fontSize: ".8rem", fontWeight: 600, color: "var(--orange)" }}>With Variables names</p>
            <p>{comp.benefitProvisionText}</p>
*/}
            {updatedBenefitProvisionText && (
                <>
                    {/*      <p style={{ padding: "1rem 0rem .4rem 0rem", fontSize: ".8rem", fontWeight: 600, color: "var(--green)" }}>With Variables values</p>*/}
                    {/* <p>{getHighlightedText(updatedBenefitProvisionText, 'category is of label')}</p> */}

                    <p>{updatedBenefitProvisionText}</p>
                </>
            )}
        </div>
    );
};

const ServiceCodes = ({ data }) => {
    if (!data?.length) return;
    return (
        <div>
            <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>Service Codes</p>
            <div className="table-wrapper" style={{ height: "auto", maxHeight: "unset" }}>
                <table>
                    <thead>
                        <tr>
                            {/* {Object.keys(isModalOpen?.details?.benefitPlanRiders?.benefitPlanRider?.[0]).map(k => <th key={k}>{k}</th>)} */}
                            <th>serviceCode</th>
                            <th>serviceShortDesc</th>
                            <th>serviceLongDesc</th>
                            <th>serviceTypeName</th>
                            {/* <th>latestVersionOfTemplate</th> */}
                        </tr>
                    </thead>

                    <tbody>
                        {data
                            // ?.filter((a) => a.benefitPlanCompName)
                            // ?.sort((a, b) => a.slotName?.localeCompare(b.slotName))
                            ?.map((r, i) => (
                                <tr key={'sc' + r.serviceCode + i}>
                                    <td>{r.serviceCode}</td>
                                    <td>{r.serviceShortDesc}</td>
                                    <td>{r.serviceLongDesc}</td>
                                    <td>{r.serviceTypeName}</td>
                                    {/* <td>{r.latestVersionOfTemplate}</td> */}
                                    {/* <td
                                                className={r.detail?.category === 'Value List' ? 'clickable-link' : ''}
                                                onClick={async () => {

                                                    // const result = await fetchValueFromValueList({ benefitPlanKey: isModalOpen.benefitPlanKey, benefitPlanHistoryFactKey: isModalOpen.benefitPlanHistoryFactKey })
                                                    // console.log(result)
                                                    setShowValueList(true)
                                                    //TODO show an hide value list
                                                }}

                                            >
                                                {r.detail?.category}
                                            </td> */}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const TransactionDIff = ({ data }) => {
    const [viewDiff, setViewDiff] = useState(false);
    return (
        <>
            <p
                className="clickable-link"
                onClick={() => setViewDiff(!viewDiff)}
                style={{
                    padding: "0rem 0rem 1rem 0rem",
                }}
            >
                {" "}
                {viewDiff ? "Hide Diff" : "Show Diff"}
            </p>

            {viewDiff && (
                <ReactDiffViewer
                    oldValue={JSON.stringify(sortByKeys(data.OldImage), null, 4)}
                    newValue={JSON.stringify(sortByKeys(data.NewImage), null, 4)}
                    disableWordDiff={true}
                    splitView={true}
                // renderContent={highlightSyntax}
                />
            )}
        </>
    );
};

const JVPayment = ({ data }) => {
    const today = new Date()

    // const bankInfo = data.details.bankInfo
    // const brokerInfo = data.details.brokerInfo
    // const brokerAddress = brokerInfo?.BrokerDemoAddress?.sort((a, b) => new Date(a.EffectiveDate) - new Date(b.EffectiveDate))?.[0];

    return <div>
        Download zelis report

    </div>
}

const JVCheckPayment = ({ data }) => {
    const today = new Date()

    // 1. Initialize state for the filename
    const [editableFileName, setEditableFileName] = useState("");

    // 2. Set the default filename when the component mounts or dates change


    const bankInfo = data?.details?.bankInfo
    // const brokerInfo = data.details.brokerInfo
    // const brokerAddress = brokerInfo?.BrokerDemoAddress?.sort((a, b) => new Date(a.EffectiveDate) - new Date(b.EffectiveDate))?.[0];
    const result = convertJsonToXml({
        _declaration: {
            _attributes: {
                version: "1.0",
            },
        },
        JavelinaReport: {
            _attributes: {
                name: "Check Report",
            },
            Source: {
                _attributes: {
                    address1: "5353 N 16th Street",
                    address2: "Suite 400",
                    city: "Pheonix",
                    state: "AZ",
                    phone: "602-604-3300",
                    company: "Mphasis Healthcare Solutions",
                    product: "Javelina",
                },
            },
            Input: {
                _attributes: {
                    aspid: "P323",
                    name: "Check Report",
                },
                Process: {
                    _attributes: {
                        class: "true",
                        query: "false",
                    },
                },
                Class: {
                    _attributes: {
                        name: "com.eldocomp.report.busobjs.billingandadmin.CheckWriter",
                        method: "process",
                    },
                },
                args: {
                    FromBlkOfBusID: {
                        _attributes: { type: "String" },
                        _text: 'CNTVO'
                    },
                    ThruBlkOfBusID: {
                        _attributes: { type: "String" },
                        _text: "CNTVO",
                    },
                    FromClientID: {
                        _attributes: { type: "String" },
                        _text: "CNTVO",
                    },
                    ThruClientID: {
                        _attributes: { type: "String" },
                        _text: "CNTVO",
                    },
                    FromLocationName: {
                        _attributes: { type: "String" },
                        _text: "",
                    },
                    ThruLocationName: {
                        _attributes: { type: "String" },
                        _text: "",
                    },
                    ClientType: {
                        _attributes: { type: "String" },
                        _text: "S",
                    },
                    CombineByTaxID: {
                        _attributes: { type: "String" },
                        _text: "N",
                    },
                    FromPayeeBrokerID: {
                        _attributes: { type: "String" },
                        _text: "",
                    },
                    ThruPayeeBrokerID: {
                        _attributes: { type: "String" },
                        _text: "",
                    },
                    FromBrokerID: {
                        _attributes: { type: "String" },
                        _text: "CJ",
                    },
                    ThruBrokerID: {
                        _attributes: { type: "String" },
                        _text: "TG",
                    },
                    BrokerType: {
                        _attributes: { type: "String" },
                        _text: "G",
                    },
                    PayThruDate: {
                        _attributes: { type: "String" },
                        _text: convertDate(today, "YYYYMMDD"),
                    },
                    FromBillingDate: {
                        _attributes: { type: "String" },
                        _text: convertDate(today, "YYYYMMDD"),
                    },
                    ThruBillingDate: {
                        _attributes: { type: "String" },
                        _text: convertDate(today, "YYYYMMDD"),
                    },
                    CheckingAccount: {
                        _attributes: { type: "String" },
                        _text: 'CNTVO',
                    },
                    Funding: {
                        _attributes: { type: "String" },
                        _text: 'N',
                    },
                    MinimumCheckAmount: {
                        _attributes: { type: "String" },
                        _text: "0.01",
                    },
                    PaymentDescription: {
                        _attributes: { type: "String" },
                        _text: "",
                    },
                    ParameterSetName: {
                        _attributes: { type: "String" },
                        _text: 'CENTIVO'
                    },
                    GeneratePDF: {
                        _attributes: { type: "String" },
                        _text: "R",
                    },
                    Vendor_id: {
                        _attributes: { type: "String" },
                        _text: "41"
                    },
                },
            },
            Output: {
                _attributes: {
                    vendor_id: "41",
                    form_name: "ACHK001",
                    aspid: "P323",
                    type: "file",
                    fileType: "xml",
                    directory: "/Javelina-4/app/p323/batch/scheduler/bin/../../reports",
                    filename: "BrokerComp",
                },

                CheckList: {
                    CheckExtractFile: {
                        CheckInfo: {
                            FirstLogoImgURL: {},
                            FirstSignImgURL: {},
                            SecondSignImgURL: {},
                            CheckNumber: {
                                _text: data?.checknumber,
                            },
                            CheckType: {},
                            CheckPurpose: {},
                            CheckFormat: {},
                            CheckAccountID: {
                                _text: data?.account_id,
                            },
                            CheckAccountNumber: {
                                _text: bankInfo?.bankaccountnumber || data?.enc_bnk_acct_num,
                            },
                            BankInfo: {
                                BankName: {
                                    _text: data?.bnk_name,
                                },
                                BankAddress: {
                                    Address1: {
                                        _text: data?.bnk_address1
                                    },
                                    Address2: {
                                        _text: data?.bnk_address2
                                    },
                                    Address3: {
                                        _text: data?.bnk_address3
                                    },
                                    City: {
                                        _text: data?.bnk_city,
                                    },
                                    State: {
                                        _text: data?.bnk_states,
                                    },
                                    PostalCode: {
                                        _text: data?.bnk_postalcode,
                                    },
                                },
                            },
                            BlockOfBusinessInfo: {
                                BlockOfBusiness: {
                                    _text: "PCP01",
                                },
                                BobName: {
                                    _text: "Self-Funded Plan",
                                },
                                BlockAddress: {
                                    Address1: {
                                        _text: '199 Scott St'
                                    },
                                    Address2: {
                                        _text: '8th Floor'
                                    },
                                    Address3: {
                                        _text: ''
                                    },
                                    City: {
                                        _text: 'Buffalo'
                                    },
                                    State: {
                                        _text: 'NY'
                                    },
                                    PostalCode: {
                                        _text: '14204'
                                    },
                                },
                            },
                            PayTo: {
                                _text: "BROKER",
                            },
                            PayViaEFT: {
                                _text: 'Y' //data?.broker_payviaeft,
                            },
                            PayeeInfo: {
                                PayeeName: {
                                    _text: data.broker_name,
                                },
                                PayeeID: {
                                    _text: data.bnk_vendor_id,
                                },
                                PayeeAddress: {
                                    Address1: {
                                        _text: data?.broker_address1
                                    },
                                    Address2: { _text: data?.broker_address2 },
                                    Address3: { _text: data?.broker_address3 },
                                    City: {
                                        _text: data?.broker_city,
                                    },
                                    County: {
                                        _text: data?.broker_county,
                                    },
                                    State: {
                                        _text: data?.broker_state,
                                    },
                                    PostalCode: {
                                        _text: data?.broker_postalcode
                                    },
                                    Country: {
                                        _text: data?.broker_country, //'UNITED STATES'
                                    },
                                },
                                PayeeTaxID: {
                                    _text: data?.broker_tax_id,
                                },
                            },
                            RoutingCodes: {},
                            ABATransitNumberPart1: { _text: bankInfo?.transitnumberpart1 || data?.abatransitnumberpart1 },
                            ABATransitNumberPart2: { _text: bankInfo?.transitnumberpart2 || data?.abatransitnumberpart2 },
                            ABATransitNumberPart3: { _text: bankInfo?.transitnumberpart3 || data?.abatransitnumberpart3 },
                            BankTransitCode: { _text: bankInfo?.routingnumber || data?.enc_transit_code },
                            CheckAmount: { _text: data?.payeeamount },
                            CheckCurrency: { _text: "US$" },
                            CheckAmountInWords: { _text: toWords.convert(data?.payeeamount || 0, { currency: true }) },
                            PaymentDate: { _text: convertDate(data?.checkissuedate, "YYYYMMDD") },
                            AlphaPaymentAmount: {},
                            MicrCode: {
                                BankTransitCode: { _text: bankInfo?.routingnumber || data?.enc_transit_code, },
                                CheckAccountNumber: { _text: bankInfo?.bankaccountnumber || data?.enc_bnk_acct_num, },
                                CheckNumber: { _text: data?.checknumber, },
                            },
                            Instrument1: {},
                            Instrument2: {},
                            Instrument3: {},
                            ClientName: { _text: data?.clientname },
                            ClientID: { _text: data?.client_id },
                            AdministratorFor: { _text: '' },
                            LineInfo: {
                                LineItemInfo: {
                                    LineAmount: {},
                                    LineDescription: {},
                                },
                            },
                        },
                        ClientIDs: { _text: data?.client_id },
                        ClientDetails: {
                            Client: {
                                ClientID: { _text: data?.client_id },
                                ClientName: { _text: data?.clientname },
                            },
                        },
                        LocationDetails: {},
                    },
                },
            },
        },
    });

    const paymentDate = convertDate(data?.checkissuedate, "YYYYMMDD") || convertDate(Date.now(), "YYYYMMDD")
    const fileName = `1422JA${paymentDate}RA1E0A1D11.xml`

    useEffect(() => {
        setEditableFileName(`1422JA${paymentDate}RA1E0A1D11.xml`);
    }, [paymentDate]);

    return <div>
        Download zelis report
        <br />
        <p>Payor: {data.account_id}</p>
        <p>Payee: {data.payeename}</p>

        <div style={{ display: 'flex', gap: '1rem' }}>
            {/* <ReactJson
                style={{ padding: "1rem", width: '50%' }}
                src={data || ""}
                name={false}
                collapsed={1}
                collapseStringsAfterLength={150}
                displayDataTypes={false}
                displayObjectSize={false}
                sortKeys={false}
            /> */}
            <XMLViewer xml={result} indentSize={12} collapsible={true} initialCollapsedDepth={10} showLineNumbers={true} />


        </div>

        <br />

        <div style={{
            display: 'flex',
            gap: '1rem',
            alignItems: 'flex-end', // This aligns the button with the input box, not the label
            width: '60%',
            marginBottom: "10px"
        }}>
            <div style={{ flex: 1 }}> {/* flex: 1 allows the input to take available space */}
                <label style={{
                    fontSize: "12px",
                    display: "block",
                    marginBottom: "4px", // Adds a tiny gap between label and input
                    fontWeight: "500",
                    color: "#666"
                }}>
                    File Name
                </label>
                <input
                    type="text"
                    value={editableFileName}
                    onChange={(e) => setEditableFileName(e.target.value)}
                    style={{
                        padding: "6px 10px",
                        width: "100%",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        boxSizing: "border-box", // Ensures padding doesn't break width
                        fontSize: "14px"
                    }}
                />
            </div>

            <button
                className="btn"
                style={{
                    height: '32px', // Matches the height of the input (padding + font + border)
                    padding: '0 15px',
                    cursor: 'pointer'
                }}
                onClick={() => downloadTxtFile(result, fileName)}
            >
                Download
            </button>
        </div>

    </div>
}

const Practitioner = ({ data }) => {
    return <div>
        <p className="sub-title">HccId: {data.practitionerHccId}</p>
        <p className="title">{`${data.practitionerFirstName} ${data.practitionerLastName}`}</p>
        <p className="sub-title">Npi: {data.practitionerNpi} </p>
        <br></br>
        <p style={{ fontWeight: 600, fontSize: "1rem", padding: "1rem 0rem" }}>Practitioner Role</p>
        <SimpleTable
            columns={[
                { label: "Practitioner RoleName", attribute: "practitionerRoleName" },
                { label: "Supplier HccId", attribute: "supplier.supplierHccId" },
                { label: "Supplier Name", attribute: "supplier.supplierName" },

                { label: "Supplier LocationHccId", attribute: "supplierLocation.supplierLocationHccId" },
                { label: "Supplier LocationName", attribute: "supplierLocation.supplierLocationName" },


                { label: "instanceActiveCode", attribute: "primarySpecialty.codeName" },
                { label: "instanceActiveCode", attribute: "primarySpecialty.code" },

                { label: "obgyn", attribute: "obgyn" },
                { label: "pcp", attribute: "pcp" },
                { label: "specialist", attribute: "specialist" },

                { label: "status", attribute: "instanceActiveCode" },
                { label: "Effective StartDate", attribute: "effectiveStartDate" },
                { label: "Endorsement Date", attribute: "endorsementDate" },
                { label: "asOfDate", attribute: "asOfDate" },


            ]}
            disableHeaderFormatting={true}
            rows={data?.details?.items?.[0]?.practitionerRole}
        />
    </div>
}